export default "/images/Avian_full.svg?67bd63276c9881de5aaf9660b0627cd7";